module.exports = __webpack_public_path__ + "img/dash.791642ab.jpg";